let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8p01i")).then(() => parcelRequire('1SZsl'));